import { gql } from 'graphql-tag';
import { pageInfoFragment } from 'src/app/shared/graphql/fragments/page-info-fragment.graphql';
import { type SearchWorkersByNameQuery } from 'src/app/shared/graphql/worker-search/search-workers-by-name-query.graphql.autogenerated';

export type SearchWorkersQueryResult = SearchWorkersByNameQuery;
export type SearchWorkersQueryResultNodes = SearchWorkersQueryResult['searchWorkersByName']['nodes'];

export const SearchWorkersByNameDocument = gql`
  query searchWorkersByName($after: String, $first: Int, $name: String!) {
    searchWorkersByName(after: $after, first: $first, name: $name) {
      nodes {
        id
        about
        normalizedType
        combinedFeedback
        deliveredHourGroup
        distanceAway
        loyaltyName
        ratings {
          id
        }
        clientFields {
          shortlisted
        }
        user {
          id
          permalink
          truncatedName
          firstName
          avatar {
            big
          }
        }
      }
      totalCount
      pageInfo {
        ...PageInfo
      }
    }
  }
  ${pageInfoFragment}
`;
